(function () {
  // The drawer and the cart page can both print this script.
  if (window.YPCartDiscountLoaded) return;
  window.YPCartDiscountLoaded = true;

  var MSG_SUCCESS = 'Code applied.';
  var MSG_INVALID = "That code isn't valid for this order.";
  var MSG_ERROR = "Couldn't apply that code. Try again at checkout.";

  function routes() {
    return (window.theme && theme.routes) || {};
  }

  function getCart() {
    return fetch(routes().cart || '/cart.js', { credentials: 'same-origin' })
      .then(function (res) { return res.json(); });
  }

  // cart.discount_codes is the only reliable answer: it lists every code the
  // session has tried, each with its own `applicable` flag. Checking
  // total_discount instead gives a false pass whenever the cart already has a
  // discount (a sitewide code like flash50), and it can never confirm a
  // free-shipping code at all, because /cart.js has no shipping in it.
  function findCode(cart, code) {
    var list = cart.discount_codes || [];
    var wanted = code.toLowerCase();
    for (var i = 0; i < list.length; i++) {
      if (String(list[i].code).toLowerCase() === wanted) return list[i];
    }
    return null;
  }

  // A code that isn't applicable is usually blocked by one that is — Shopify
  // only stacks codes when both are set to combine. Naming the culprit is more
  // use to the shopper than "invalid".
  function blockingCode(cart, code) {
    var list = cart.discount_codes || [];
    var entered = code.toLowerCase();
    for (var i = 0; i < list.length; i++) {
      if (list[i].applicable && String(list[i].code).toLowerCase() !== entered) return list[i].code;
    }
    return null;
  }

  function CartDiscount(el) {
    this.el = el;
    this.toggle = el.querySelector('[data-discount-toggle]');
    this.panel = el.querySelector('[data-discount-panel]');
    this.input = el.querySelector('[data-discount-input]');
    this.apply = el.querySelector('[data-discount-apply]');
    this.msg = el.querySelector('[data-discount-msg]');
    this.busy = false;

    if (!this.toggle || !this.panel || !this.input || !this.apply) return;

    this.toggle.addEventListener('click', this.onToggle.bind(this));
    this.apply.addEventListener('click', this.onApply.bind(this));

    // Enter applies the code instead of submitting the cart form (which would
    // send the shopper straight to checkout).
    this.input.addEventListener('keydown', function (evt) {
      if (evt.key !== 'Enter') return;
      evt.preventDefault();
      this.onApply();
    }.bind(this));
  }

  CartDiscount.prototype.onToggle = function () {
    var open = this.toggle.getAttribute('aria-expanded') === 'true';
    this.toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
    this.el.classList.toggle('is-open', !open);
    this.panel.hidden = open;
    if (!open) this.input.focus();
  };

  CartDiscount.prototype.setMessage = function (text, kind) {
    if (!this.msg) return;
    this.msg.textContent = text || '';
    this.msg.hidden = !text;
    this.msg.classList.toggle('cart-discount__msg--ok', kind === 'ok');
    this.msg.classList.toggle('cart-discount__msg--error', kind === 'error');
  };

  CartDiscount.prototype.setBusy = function (busy) {
    this.busy = busy;
    this.apply.disabled = busy;
    this.el.classList.toggle('is-busy', busy);
  };

  CartDiscount.prototype.onApply = function () {
    if (this.busy) return;

    var code = (this.input.value || '').trim();
    if (!code) {
      this.input.focus();
      return;
    }

    var self = this;
    this.setMessage('');
    this.setBusy(true);

    // /discount/CODE applies the code to the session, then redirects. We only
    // care that the request completes; the cart tells us whether it stuck.
    fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' })
      .then(getCart)
      .then(function (cart) {
        var entry = findCode(cart, code);

        if (entry && entry.applicable) {
          self.setMessage(MSG_SUCCESS, 'ok');
          self.input.value = '';
          document.dispatchEvent(new CustomEvent('cart:build'));
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
          return;
        }

        // Shopify marks an unrecognised code and a valid-but-non-combining one
        // the same way (applicable: false), so the message must cover both
        // rather than claim to know which it was.
        var blocker = blockingCode(cart, code);
        if (blocker) {
          self.setMessage("That code isn't valid for this order, or it can't be combined with " + blocker + '.', 'error');
        } else {
          self.setMessage(MSG_INVALID, 'error');
        }
      })
      .catch(function () {
        self.setMessage(MSG_ERROR, 'error');
      })
      .then(function () {
        self.setBusy(false);
      });
  };

  function init() {
    document.querySelectorAll('[data-cart-discount]').forEach(function (el) {
      if (el.discountInstance) return;
      el.discountInstance = new CartDiscount(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
